import React from 'react';
import squareDetail from '../img/Detail/Square-Detail.jpg';
import './Detail.css';
const SquareDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={squareDetail} alt="Square! Game Design" />
    </div>
  );
};

export default SquareDetail;
